var search = ( function( $ ) {

	var timeoutID;

	var _init = function() {
		$( '.top-panel-search-toggle' ).on( 'click', _top_panel_toggle );

		$( '.searchform input[type=submit]' ).hide();

		$( '.searchform .search-toggle' ).on( 'click', _form_toggle ).show();

		// On blur - contract it if its empty
		$( '.searchform #s' ).on( 'blur', _form_blur );
	};

	var _form_toggle = function() {
		window.clearTimeout( timeoutID );

		var $form = $( this ).closest( '.searchform' );
		var $input = $(this).siblings( '#s' );

		if ( $input.hasClass( 'contracted' ) ) {
			// Not open - expand and set focus
			$input.removeClass( 'contracted' );
			$input.focus();
		} else if ( ! $.trim( $input.val() ).length ) {
			// Open but empty - contract
			$input.addClass( 'contracted' );
		} else {
			// Open and filled in - submit
			$form.submit();
		}

		return false;
	};

	var _form_blur = function( event ) {
		var $s = $( this );

		timeoutID = window.setTimeout(function() {
			if ( ! $s.hasClass( 'contracted' ) && ! $.trim( $s.val() ).length ) {
				$s.addClass( 'contracted' )
			}
		}, 500);
	};

	var _top_panel_toggle = function( event ) {
		// Close all other top panels
		$( '.top-panel' ).not( '#search-top-panel' ).removeClass( 'open' );

		// Open search
		var $panel = $( '#search-top-panel' );
		$panel.toggleClass( 'open' );

		if ( $panel.hasClass( 'open' ) ) {
			$panel.find( 'input[name=s]' ).focus();
		} else {
			$panel.find( 'input[name=s]' ).blur();
		}

		event.preventDefault();
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = search;